<template>
    <div>
        <div class="p-fluid">
            <div class="formgrid grid">
                <div class="field col-12 md:col-6 lg:col-3">
                    <label>Territory</label>
                    <Dropdown id="territory_id" dataKey="territory_id" v-model="filters.territory_id" :loading="loadingDropdownTerritory"
                        :options="dataDropdownTerritory"
                        optionLabel="territory_label" optionValue="territory_id" placeholder="Select Territory"
                        :filter="true" :showClear="true" @filter="searchDropdownTerritory($event, 'filter')" 
                        @change="changeCity()"/>
                </div>
                <div class="field col-12 md:col-6 lg:col-3">
                    <label>Town</label>
                    <Dropdown id="city_id" dataKey="city_id" v-model="filters.city_id" :loading="loadingDropdownCity"
                        :options="dataDropdownCity"
                        optionLabel="city_name" optionValue="city_id" placeholder="Select Town"
                        :filter="true" :showClear="true" @filter="searchDropdownTown($event, 'filter')" />
                </div>
            </div>
        </div>
        <Button :loading="loading" label="Filter" icon="pi pi-search" class="p-button-warning mr-2 my-1" @click="getDataTable" />
    </div>
</template>

<script>

export default {
    data() {
        return {
            // loading
            loading: false,
            loadingDropdownTerritory: false,
            loadingDropdownCity: false,

            // dataDropdown
            dataDropdownTerritory: null,
            dataDropdownCity: null,

            // filter
            filters: {
                territory_id: null,
                city_id: null,
            },
        }
    },
    mounted() {
        this.searchDropdownTerritory('');
    },
    created(){
    },
    watch: {
    },
    computed:{
    },
    methods: {
        // DROPDOWN
        searchDropdownTerritory(event, purpose, valueEdit) {
            setTimeout(() => {

                if (valueEdit) {
                    this.$refs.dterritory.filterValue = valueEdit;
                }

                if (purpose == "filter") {
                    this.loadingDropdownTerritory = true;
                }

                this.axios({
                    method: 'GET',
                    url: process.env.VUE_APP_ROOT_API + 'web/select2/master-territory',
                    params: {
                        "search": valueEdit ? valueEdit : event.value,
                    }
                })
                    .then(res => {

                        if (purpose == "filter") {
                            this.dataDropdownTerritory = res.data.data;
                            this.loadingDropdownTerritory = false;
                        } else if (purpose == null) {
                            this.dataDropdownTerritory = res.data.data;
                        }
                    })
                    .catch((err) => {
                        console.log(err);
                    });
            }, 250);
        },
        changeCity() {
            this.filters.city_id = null;
            this.dataDropdownCity = null;
            this.searchDropdownCity('');
        },
        searchDropdownCity(event, purpose, valueEdit) {
            setTimeout(() => {

                if(this.filters.territory_id){
                    if (valueEdit) {
                        this.$refs.dcity.filterValue = valueEdit;
                    }

                    if (purpose == "filter") {
                        this.loadingDropdownCity = true;
                    }

                    this.axios({
                        method: 'GET',
                        url: process.env.VUE_APP_ROOT_API + 'web/select2/master-city2',
                        params: {
                            "search": valueEdit ? valueEdit : event.value,
                            "territory_id": this.filters.territory_id,
                        }
                    })
                    .then(res => {

                        if (purpose == "filter") {
                            this.dataDropdownCity = res.data.data;
                            this.loadingDropdownCity = false;
                        } else if (purpose == null) {
                            this.dataDropdownCity = res.data.data;
                        }
                    })
                    .catch((err) => {
                        console.log(err);
                    });
                }

            }, 250);
        },
        getDataTable(){
            this.$emit('submit');
        }
    }
}
</script>

